export default "__VITE_ASSET__DpqUdVQs__"